<label for="search_{{ unifyKey(column.key) }}">
  <input
    nbInput
    fieldSize="small"
    type="text"
    id="search_{{ unifyKey(column.key) }}"
    aria-label="Search"
    placeholder="{{ column.placeholder ? column.placeholder : column.title }}"
    #input
    (keyup)="onKey(input, $event)"
    (input)="onSearch(input)"
  />
</label>
